import AddIcon from '@mui/icons-material/Add';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, MenuItem, Paper, Radio, RadioGroup, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthUser } from '../../interfaces/Contexts';
import { getMentorsList, postadddocumentgoals, postaddgoalsmilestone } from '../../Utils/apiService';
import routes from '../../Utils/routes';
import formData from './form.json';
import { useStyles } from './styles';
import KenLoader from '../../GlobalComponents/KenLoader';

type FormValues = { [key: string]: string | boolean };

// Define the structure for Goal data
type Goal = {
  GoalName: string;
  Duration: string;
  ChooseMentor: string;
  ProgressMeasurement: string;
  ProgressPercentage: string;
  GoalProgress: boolean;
};

const AddMilestones: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log(state, 'state from location');

  const classes = useStyles();
  const userData = JSON.parse(localStorage.getItem('user') || '{}') as AuthUser;
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState<FormValues>({});
  const [mentors, setMentors] = useState<any[]>([]);
  const [fileName, setFileName] = useState<any[]>();
  const [selectedMentor, setSelectedMentor] = useState<{ id: string; name: string }>({ id: '', name: '' });
  const [selectedMentorId, setSelectedMentorId] = useState<string>('');

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    // Trigger the file input click programmatically
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // useEffect(() => {
   
  // }, [state.dataFor]);

  // Fetch mentors list when the component mounts
  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const response = await getMentorsList();
        if (response.status === 'true') {
          setMentors(response.result); // Store the fetched mentors in state
        }
      } catch (error) {
        console.error('Error fetching mentors:', error);
      }
    };

    fetchMentors();
  }, []);

  const handleMentorChange = (event: SelectChangeEvent<string | true>) => {
    const mentorId = event.target.value as string;

    // Find the selected mentor
    const mentor = mentors.find((mentor) => mentor.id === mentorId);

    if (mentor) {
      setFormValues({
        ...formValues,
        Category: mentorId, // Store the mentor ID
        SelectedMentorName: mentor.name, // Optionally store the mentor name
      });
    }
  };

  const [goals, setGoals] = useState<Goal[]>([
    {
      GoalName: '',
      Duration: '',
      ChooseMentor: '',
      ProgressMeasurement: '',
      ProgressPercentage: '',
      GoalProgress: false,
    },
  ]);

  const handleChange = (name: string, value: string | boolean) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleGoalChange = (index: number, name: string, value: string | boolean) => {
    const updatedGoals = [...goals];
    updatedGoals[index] = {
      ...updatedGoals[index],
      [name]: value,
    };
    setGoals(updatedGoals);
  };
  const handleFileChange = async (event: any) => {
    const file = event.target.files[0];
    setFileName(file.name);
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await postadddocumentgoals(formData);
        if (response.status === 'true' && response.result.success) {
          const documentUrl = response.result.message;
          setFormValues((prevValues) => ({
            ...prevValues,
            SupportingDocument: documentUrl,
          }));
        } else {
          console.error('Error uploading document:', response.result.message);
        }
      } catch (error) {
        console.error('Error uploading document:', error);
      }
    }
  };

  // Handle adding a new goal
  const handleAddGoal = () => {
    const newGoal: Goal = {
      GoalName: '',
      Duration: '',
      ChooseMentor: '',
      ProgressMeasurement: '',
      ProgressPercentage: '',
      GoalProgress: false,
    };
    setGoals((prevGoals) => [...prevGoals, newGoal]);
  };

  const handleSubmit = async () => {
    const dataToSubmit = {
      mentorId: formValues['Category'],
      mentorName: formValues['SelectedMentorName'],
      menteeId: userData?.accountId,
      milestoneName: formValues.Name,
      milestoneDuration: formValues.Duration,
      progressUpdateMethod: formValues['based on goals'],
      startValue: formValues['starting value'],
      currentValue: formValues['current value'],
      target: formValues['target'],
      supportingDocumentUrl: formValues.SupportingDocument,
      goals: goals.map((goal) => ({
        goalName: goal.GoalName,
        goalDuration: goal.Duration,
      })),
    };

    console.log('Data to Submit:', dataToSubmit);
    setLoading(true);

    try {
      const response = await postaddgoalsmilestone(dataToSubmit);
      console.log('API Response:', response);
      setFormValues({
        Name: '',
        Duration: '',
        'based on goals': '',
        'starting value': '',
        'current value': '',
        target: '',
        SupportingDocument: '',
      });

      setGoals([
        {
          GoalName: '',
          Duration: '',
          ChooseMentor: '',
          ProgressMeasurement: '',
          ProgressPercentage: '',
          GoalProgress: false,
        },
      ]);

      // Optionally, show a success message (e.g., using snackbar)
      setLoading(false);
      navigate(routes.goalsAndMilestones);
      enqueueSnackbar('Successfully submitted the form!', { variant: 'success' });
    } catch (error) {
      console.error('Error submitting data:', error);
      setLoading(false);
      enqueueSnackbar('Error submitting the form. Please try again.', { variant: 'error' });
    }
  };
  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <Box>
          <Paper className={classes.card}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={5} md={5} xl={6}>
                <Box>
                  <Typography className={classes.milestonetitle}>Add Milestones</Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '24px', ultraD: '18px' }, mt: { xs: '24px', ultraD: '18px' } }}>
                    {formData.fields.map((field) => {
                      if (field.type === 'text' && field.name === 'Name') {
                        return (
                          <Box>
                            <Typography className={classes.label} sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
                              {field.label}
                            </Typography>
                            <TextField
                              fullWidth
                              type={field.type}
                              placeholder={field.placeholder}
                              value={formValues[field.name] || ''}
                              onChange={(e) => handleChange(field.name, e.target.value)}
                              sx={{ fontSize: { xs: '12px', ultraHD: '16px' }, borderRadius: { xs: '6px', ultraHD: '8px' } }}
                              InputProps={{
                                sx: {
                                  height: { xs: '45px', ultraHD: '60px' },
                                  borderRadius: { xs: '6px', ultraHD: '8px' },
                                },
                              }}
                            />
                            {/* <Typography style={{ display: 'flex', fontSize: '12px' }}>{field.label}</Typography>
                        <TextField
                          key={field.name}
                          fullWidth
                          label={field.label}
                          value={formValues[field.name] || ''}
                          className={classes.textfield}
                          onChange={(e) => handleChange(field.name, e.target.value)}
                          placeholder={field.placeholder}
                        /> */}
                          </Box>
                        );
                      }
                    })}

                    <Grid container spacing={2}>
                      {formData.fields.map((field) => {
                        if (field.type === 'select' && (field.name === 'Category' || field.name === 'Priority')) {
                          return (
                            <Grid item xs={6} key={field.name}>
                              <FormControl fullWidth>
                                <Typography className={classes.label} sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
                                  {field.label}
                                </Typography>
                                <Select
                                  fullWidth
                                  id={field.name}
                                  value={formValues[field.name] || ''}
                                  labelId={`${field.name}-label`}
                                  onChange={(e) => (field.name === 'Category' ? handleMentorChange(e) : handleChange(field.name, e.target.value))}
                                  placeholder={field.placeholder}
                                  sx={{
                                    height: { xs: '45px', ultraHD: '60px' },
                                    fontSize: { xs: '12px', ultraHD: '16px' },
                                    borderRadius: { xs: '6px', ultraHD: '8px' },
                                  }}
                                >
                                  {field.name === 'Category' && mentors
                                    ? mentors.map((mentor) => (
                                        <MenuItem key={mentor.id} value={mentor.id} sx={{ fontSize: { xs: '12px', ultraHD: '16px' } }}>
                                          {mentor.name}
                                        </MenuItem>
                                      ))
                                    : Array.isArray(field.options) &&
                                      field.options.map((option, index) => (
                                        <MenuItem key={index} value={option} sx={{ fontSize: { xs: '12px', ultraHD: '16px' } }}>
                                          {option}
                                        </MenuItem>
                                      ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                    <Grid container spacing={2}>
                      {formData.fields.map((field) => {
                        if (field.type === 'select' && field.name === 'DocumentType') {
                          return (
                            <Grid item xs={6} key={field.name}>
                              <FormControl fullWidth>
                                <Typography className={classes.label} sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
                                  {field.label}
                                </Typography>
                                <Select
                                  id={field.name}
                                  labelId={`${field.name}-label`}
                                  value={formValues[field.name] || ''}
                                  onChange={(e) => handleChange(field.name, e.target.value)}
                                  className={classes.textfield}
                                  placeholder={field.label}
                                  sx={{
                                    height: { xs: '45px', ultraHD: '60px' },
                                    fontSize: { xs: '12px', ultraHD: '16px' },
                                    borderRadius: { xs: '6px', ultraHD: '8px' },
                                  }}
                                >
                                  {Array.isArray(field.options) &&
                                    field.options.map((option, index) => (
                                      <MenuItem key={index} value={option} sx={{ fontSize: { xs: '12px', ultraHD: '16px' } }}>
                                        {option}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          );
                        }

                        if (field.type === 'file' && field.name === 'SupportingDocument') {
                          return (
                            <Grid item xs={6} key={field.name}>
                              <Typography className={classes.label} sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
                                Upload Supporting Document
                              </Typography>
                              <Button
                                aria-label="Upload File"
                                title="Upload File"
                                onClick={handleButtonClick}
                                sx={{
                                  height: { xs: '45px', ultraHD: '60px' },
                                  color: fileName ? '#4c155f' : '#B0B0B0',
                                  border: '1px solid #B0B0B0',
                                  fontWeight: fileName ? '500' : '400',
                                  textDecoration: fileName ? 'underline' : 'none',
                                  fontSize: { xs: '12px', ultraHD: '16px' },
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                }}
                                variant="outlined"
                                fullWidth
                                endIcon={<FileUploadOutlinedIcon />}
                              >
                                {fileName ? fileName : field.label}
                                <input type="file" ref={fileInputRef} style={{ display: 'none', width: '100%' }} onChange={(e) => handleFileChange(e)} />
                              </Button>
                            </Grid>
                          );
                        }

                        return null;
                      })}
                    </Grid>

                    {/* How will you measure progress */}
                    <Typography className={classes.milestonetitle}>How will you measure progress</Typography>
                    <Grid container spacing={2}>
                      {formData.fields.map((field) => {
                        if (field.type === 'select' && (field.name === 'based on goals' || field.name === 'starting value')) {
                          return (
                            <Grid item xs={6} key={field.name}>
                              <FormControl fullWidth>
                                <Typography className={classes.label} sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
                                  {field.label}
                                </Typography>
                                <Select
                                  id={field.name}
                                  labelId={`${field.name}-label`}
                                  value={formValues[field.name] || ''}
                                  className={classes.textfield}
                                  onChange={(e) => handleChange(field.name, e.target.value)}
                                  placeholder={field.label}
                                  sx={{
                                    height: { xs: '45px', ultraHD: '60px' },
                                    fontSize: { xs: '12px', ultraHD: '16px' },
                                    borderRadius: { xs: '6px', ultraHD: '8px' },
                                  }}
                                >
                                  {Array.isArray(field.options) &&
                                    field.options.map((option, index) => (
                                      <MenuItem key={index} value={option} sx={{ fontSize: { xs: '12px', ultraHD: '16px' } }}>
                                        {option}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                    <Grid container spacing={2}>
                      {formData.fields.map((field) => {
                        if (field.type === 'select' && (field.name === 'current value' || field.name === 'target')) {
                          return (
                            <Grid item xs={6} key={field.name}>
                              <FormControl fullWidth>
                                <Typography className={classes.label} sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
                                  {field.label}
                                </Typography>
                                <Select
                                  id={field.name}
                                  labelId={`${field.name}-label`}
                                  value={formValues[field.name] || ''}
                                  onChange={(e) => handleChange(field.name, e.target.value)}
                                  className={classes.textfield}
                                  placeholder={field.label}
                                  sx={{
                                    height: { xs: '45px', ultraHD: '60px' },
                                    fontSize: { xs: '12px', ultraHD: '16px' },
                                    borderRadius: { xs: '6px', ultraHD: '8px' },
                                  }}
                                >
                                  {Array.isArray(field.options) &&
                                    field.options.map((option, index) => (
                                      <MenuItem key={index} value={option} sx={{ fontSize: { xs: '12px', ultraHD: '16px' } }}>
                                        {option}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={0.5}>
                <Box className={classes.verticalDivider} />
              </Grid>

              {/* Goal Section */}
              <Grid item xs={12} sm={5.5} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Box sx={{ height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <Box sx={{ flex: 1 }}>
                    {goals.map((goal, index) => (
                      <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {/* Goal Title */}
                        <Typography className={classes.milestonetitle}>Goal #{index + 1}</Typography>

                        {/* Goal Name TextField */}
                        {formData.fields.map((field) => {
                          if (field.type === 'text' && field.name === 'GoalName') {
                            return (
                              <>
                                <Typography className={classes.label} sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
                                  {field.label}
                                </Typography>
                                <TextField
                                  className={classes.textfield}
                                  key={field.name}
                                  fullWidth
                                  value={goal.GoalName || ''}
                                  onChange={(e) => handleGoalChange(index, 'GoalName', e.target.value)}
                                  placeholder={field.placeholder}
                                  InputProps={{
                                    sx: {
                                      height: { xs: '45px', ultraHD: '60px' },
                                      borderRadius: { xs: '6px', ultraHD: '8px' },
                                    },
                                  }}
                                />
                              </>
                            );
                          }
                          return null;
                        })}
                        <Grid container spacing={2}>
                          {formData.fields.map((field) => {
                            if (field.type === 'select' && (field.name === 'Duration' || field.name === 'ChooseMentor')) {
                              return (
                                <Grid item xs={6} key={field.name}>
                                  <FormControl fullWidth>
                                    <Typography className={classes.label} sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
                                      {field.label}
                                    </Typography>
                                    <Select
                                      id={field.name}
                                      labelId={`${field.name}-label`}
                                      className={classes.textfield}
                                      value={goal[field.name] || ''}
                                      onChange={(e) => handleGoalChange(index, field.name, e.target.value)}
                                      placeholder={field.label}
                                      sx={{
                                        height: { xs: '45px', ultraHD: '60px' },
                                        fontSize: { xs: '12px', ultraHD: '16px' },
                                        borderRadius: { xs: '6px', ultraHD: '8px' },
                                      }}
                                    >
                                      {field.name === 'ChooseMentor' && mentors
                                        ? mentors.map((mentor) => (
                                            <MenuItem key={mentor.id} value={mentor.id} sx={{ fontSize: { xs: '12px', ultraHD: '16px' } }}>
                                              {mentor.name} {/* Mentor name */}
                                            </MenuItem>
                                          ))
                                        : Array.isArray(field.options) &&
                                          field.options.map((option, index) => (
                                            <MenuItem key={index} value={option} sx={{ fontSize: { xs: '12px', ultraHD: '16px' } }}>
                                              {option}
                                            </MenuItem>
                                          ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                              );
                            }
                            return null;
                          })}
                        </Grid>

                        {/* Goal Measurement */}
                        <Typography className={classes.milestonetitle}>Goal Measurement</Typography>
                        <Typography className={classes.milestonesubtitle}>How do you want to measure the progress of your goal.</Typography>

                        {/* Progress Measurement Radio Group */}
                        {formData.fields.map((field) => {
                          if (field.type === 'radio' && field.name === 'ProgressMeasurement') {
                            return (
                              <FormControl component="fieldset" key={field.name} sx={{ pl: '2px' }}>
                                <RadioGroup value={goal.ProgressMeasurement || ''} onChange={(e: any) => handleGoalChange(index, 'ProgressMeasurement', e.target.value)} row>
                                  {Array.isArray(field.options) &&
                                    field.options.length > 0 &&
                                    field.options.map((option, index) => (
                                      <FormControlLabel
                                        key={index}
                                        value={option}
                                        control={
                                          <Radio
                                            sx={{
                                              '& .MuiSvgIcon-root': {
                                                fontSize: { xs: '16px', ultraHD: '20px' },
                                              },
                                            }}
                                          />
                                        }
                                        label={option}
                                        className={classes.radioLabel}
                                      />
                                    ))}
                                </RadioGroup>
                              </FormControl>
                            );
                          }
                          return null;
                        })}

                        {/* Progress Percentage TextField */}
                        {formData.fields.map((field) => {
                          if (field.type === 'text' && field.name === 'Progress-Percentage') {
                            return (
                              <>
                                <Typography className={classes.label}>{field.label}</Typography>
                                <TextField
                                  className={classes.textfield}
                                  key={field.name}
                                  fullWidth
                                  value={goal.ProgressPercentage || ''}
                                  onChange={(e) => handleGoalChange(index, 'ProgressPercentage', e.target.value)}
                                  placeholder={field.placeholder}
                                  InputProps={{
                                    sx: {
                                      height: { xs: '45px', ultraHD: '60px' },
                                      borderRadius: { xs: '6px', ultraHD: '8px' },
                                    },
                                  }}
                                />
                              </>
                            );
                          }
                          return null;
                        })}

                        {/* Goal Progress Checkbox */}
                        <FormControlLabel
                          className={classes.milestonesubtitle}
                          control={
                            <Checkbox
                              checked={goal.GoalProgress}
                              onChange={(e) => handleGoalChange(index, 'GoalProgress', e.target.checked)}
                              name="GoalProgress"
                              sx={{
                                pl: '12px',
                                '& .MuiSvgIcon-root': {
                                  fontSize: { xs: '16px', ultraHD: '20px' },
                                },
                              }}
                            />
                          }
                          label="Goal progress to add up to milestone progress"
                        />
                      </div>
                    ))}

                    {/* Add Goal Button */}
                    <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddGoal} className={classes.addMilestoneBtn}>
                      Add Goal
                    </Button>
                  </Box>

                  {/* Submit & Cancel Buttons */}
                  <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
                    <Grid item>
                      <Button
                        onClick={() => navigate(routes.goalsAndMilestones)}
                        sx={{
                          color: '#604797',
                          fontSize: { xs: '12px', ultraHD: '16px' },
                          fontWeight: '500',
                          '&:hover': {
                            color: '#604797',
                          },
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        sx={{
                          height: { xs: '32px', ultraHD: '42px' },
                          width: { xs: '90px', ultraHD: '120px' },
                          fontSize: { xs: '12px', ultraHD: '16px' },
                          boxShadow: 'none',
                          borderRadius: { xs: '5px', ultraHD: '7px' },
                        }}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      )}
    </>
  );
};

export default AddMilestones;
